import React from 'react'
import { D2C_ROLE_GATING } from '../../pages/d2c-pricing-agent/constants'
import { GROWTHOS_ROLE_GATING } from '../../pages/growthos-brands/constants'
import { PTL_EDD_ADMIN_ACCESS } from '../../pages/ptl-edd-breach/constants'
import { DIRECT_ROLE_GATING } from '../../pages/direct/constants'
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined'
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined'
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined'
import LeaderboardRoundedIcon from '@mui/icons-material/LeaderboardRounded'
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined'
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined'
import RocketLaunchOutlinedIcon from '@mui/icons-material/RocketLaunchOutlined'
import LeaderboardOutlinedIcon from '@mui/icons-material/LeaderboardOutlined'
import AirportShuttleOutlinedIcon from '@mui/icons-material/AirportShuttleOutlined'
import ScaleOutlinedIcon from '@mui/icons-material/ScaleOutlined'
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined'
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined'
import SettingsInputCompositeOutlinedIcon from '@mui/icons-material/SettingsInputCompositeOutlined'
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined'
import StorageOutlinedIcon from '@mui/icons-material/StorageOutlined'
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined'
import InsightsOutlinedIcon from '@mui/icons-material/InsightsOutlined'
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined'
import AssignmentLateOutlinedIcon from '@mui/icons-material/AssignmentLateOutlined'
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined'
import EventNoteOutlinedIcon from '@mui/icons-material/EventNoteOutlined'
import TravelExploreOutlinedIcon from '@mui/icons-material/TravelExploreOutlined'
import PriceChangeOutlinedIcon from '@mui/icons-material/PriceChangeOutlined'
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined'
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined'
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined'
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined'
import { EMS_V2_ENABLED } from '../../routes/emsV2Visibility'

const MENU_ITEMS = [
  {
    name: 'Home',
    icon: <HomeOutlinedIcon />,
    url: '/home',
    role: ['B2C_ACCESS', 'PTL_ACCESS', 'DASHBOARD', 'INTERNAL', 'TOOLS', 'FINANCE', 'REPORTS', 'NDR', 'WEIGHT_DESC', 'SA', 'USER_SAVE', 'USER_RO'],
  },

  {
    name: 'ProPilot AI',
    icon: <AutoAwesomeOutlinedIcon />,
    url: '/propilot',
    role: ['TOOLS'],
  },

  // ═══════════════════════════════════════════════════════════════════════════
  // ██  D2C FREIGHT  ██
  // ═══════════════════════════════════════════════════════════════════════════
  { type: 'section', name: 'D2C FREIGHT' },

  {
    name: 'D2C Dashboard',
    icon: <DashboardOutlinedIcon />,
    url: '/dashboard/d2c',
    role: ['DASHBOARD', 'B2C_ACCESS'],
    submenu: [
      {name: "Today's Overview", url: '/dashboard/d2c?tab=1'},
      {name: 'Unprocessed Orders', url: '/dashboard/d2c?tab=2'},
      {name: 'Realised Revenue', url: '/dashboard/d2c?tab=3'},
      {name: 'Overall Shipments', url: '/dashboard/d2c?tab=4'},
    ],
  },

  // ── Shipment Management ─────────────────────────────────────────────────
  {
    name: 'Shipment Management',
    icon: <LocalShippingOutlinedIcon />,
    url: '/d2c/orders/forward',
    role: ['B2C_ACCESS'],
    submenu: [
      { name: 'Forward & Reverse', url: '/d2c/orders/forward', submenu: [
        { name: 'Forward Shipments', url: '/d2c/orders/forward' },
        { name: 'Reverse Shipments', url: '/d2c/orders/reverse' },
        { name: 'Channel Orders', url: '/d2c/orders/channel' },
      ]},
      { name: 'Unprocessed Orders', url: '/d2c/orders/unprocessed-forward', submenu: [
        { name: 'Unprocessed Forward', url: '/d2c/orders/unprocessed-forward' },
        { name: 'Unprocessed Reverse', url: '/d2c/orders/unprocessed-reverse' },
      ]},
      { name: 'Operations', url: '/d2c/operations/cancellation-pending', submenu: [
        { name: 'Cancellation Pending', url: '/d2c/operations/cancellation-pending' },
        { name: 'Bulk Tracking', url: '/d2c/operations/bulk-tracking' },
        { name: 'Manual Status Update', url: '/d2c/operations/manual-status-update' },
        // V1 and EMS V2 side by side until go-live (REACT_APP_EMS_V2_ENABLED, see emsV2Visibility.js).
        ...(EMS_V2_ENABLED
          ? [{ name: 'Escalation Management', url: '/tools/escalation-v2' }]
          : [
              { name: 'Escalation Management', url: '/tools/escalation' },
              { name: 'Escalation Management V2', url: '/tools/escalation-v2' },
            ]),
      ]},
      { name: 'Bulk Downloads', url: '/d2c/downloads/labels', submenu: [
        { name: 'Download Labels', url: '/d2c/downloads/labels' },
        { name: 'Download Invoices', url: '/d2c/downloads/invoice' },
      ]},
    ],
  },

  // ── Delivery Performance ────────────────────────────────────────────────
  {
    name: 'Delivery Performance',
    icon: <WarningAmberOutlinedIcon />,
    url: '/ndr-npr/ndr/open',
    // NDR sees the NDR/NPR/Intervention children; INTERNAL sees Intelligent EDD (PRISM).
    // Children carry explicit roles so broadening the group doesn't leak NDR items to INTERNAL.
    role: ['NDR', 'INTERNAL'],
    submenu: [
      { name: 'Non-Delivery (NDR)', url: '/ndr-npr/ndr/open', role: ['NDR'], submenu: [
        { name: 'Open NDR', url: '/ndr-npr/ndr/open' },
        { name: 'Closed NDR', url: '/ndr-npr/ndr/closed' },
        { name: 'NDR Bulk Upload', url: '/ndr-npr/ndr/bulk-upload' },
        { name: 'NDR Call Recordings', url: '/ndr-npr/ndr/calls' },
        { name: 'WhatsApp Automation', url: '/ndr-npr/ndr/whatsapp' },
        { name: 'NDR Scope', url: '/ndr-npr/ndr/scope' },
      ]},
      { name: 'Non-Pickup (NPR)', url: '/ndr-npr/npr/open', role: ['NDR'], submenu: [
        { name: 'Open NPR', url: '/ndr-npr/npr/open' },
        { name: 'Closed NPR', url: '/ndr-npr/npr/closed' },
        { name: 'NPR Bulk Upload', url: '/ndr-npr/npr/bulk-upload' },
        { name: 'NPR Call Recordings', url: '/ndr-npr/npr/calls' },
      ]},
      { name: 'Intervention Analytics', url: '/intervention/dashboard', role: ['NDR'], submenu: [
        { name: 'Analytics Dashboard', url: '/intervention/dashboard' },
        { name: 'NDR Drilldown', url: '/intervention/ndr' },
        { name: 'NPR Drilldown', url: '/intervention/npr' },
        { name: 'Call Analytics', url: '/intervention/calls' },
        { name: 'Call Recordings', url: '/intervention/calls/recordings' },
        { name: 'WhatsApp Analytics', url: '/intervention/whatsapp' },
        { name: 'Templates', url: '/intervention/templates' },
        { name: 'Rules', url: '/intervention/rules' },
        { name: 'Cost Analytics', url: '/intervention/cost' },
      ]},
      { name: 'Intelligent EDD (PRISM)', url: '/prism/iedd', role: ['INTERNAL'] },
    ],
  },

  // ── Automated Allocation ────────────────────────────────────────────────
  {
    name: 'Automated Allocation',
    icon: <RocketLaunchOutlinedIcon />,
    url: '/pace/allocation',
    role: ['TOOLS'],
    submenu: [
      { name: 'About PACE', url: '/pace/about' },
      { name: 'Allocation Rules', url: '/pace/allocation' },
      { name: 'Allocations', url: '/pace/allocations' },
      { name: 'Analytics', url: '/pace/analytics' },
      { name: 'Daily PACE Share', url: '/pace/daily-share' },
      { name: 'Shipment Counts', url: '/pace/shipment-counts' },
      { name: 'Business Knobs', url: '/pace/business-knobs' },
      { name: 'Service Types', url: '/pace/service-types' },
      { name: 'Merchant List', url: '/pace/merchant-list' },
      { name: 'Onboarded Merchants', url: '/pace/onboarded-merchants' },
      { name: 'External Shadow Run', url: '/pace/external-shadow-run' },
    ],
  },

  // ── Courier Performance ─────────────────────────────────────────────────
  {
    name: 'Courier Performance',
    icon: <LeaderboardOutlinedIcon />,
    url: '/courier-benchmarking',
    // DASHBOARD sees the benchmarking tabs; ROLE_PROSHIPADMIN sees Reverse QC Coverage and Payment Mode Compliance.
    // Children carry explicit roles so broadening the group doesn't leak benchmarking to admins without DASHBOARD.
    role: ['DASHBOARD', 'ROLE_PROSHIPADMIN'],
    submenu: [
      {name: 'Forward Performance', url: '/courier-benchmarking?tab=forward', role: ['DASHBOARD']},
      {name: 'Reverse Performance', url: '/courier-benchmarking?tab=reverse', role: ['DASHBOARD']},
      // Backend is ROLE_PROSHIPADMIN-only; the sidebar merges JWT roles into the access list, so gate the leaf on it too.
      {name: 'Reverse QC Coverage', url: '/courier-performance/qc-monitor', role: ['ROLE_PROSHIPADMIN']},
      {name: 'Comparison', url: '/courier-benchmarking?tab=comparison', role: ['DASHBOARD']},
      // Payment Mode Compliance — are orders going to courier accounts that can carry their payment mode?
      // Backend is ROLE_PROSHIPADMIN only (no separate module), so gate on the JWT role.
      {name: 'Payment Mode Compliance', url: '/courier-performance/payment-mode-compliance', role: ['ROLE_PROSHIPADMIN']},
    ],
  },

  // ── Serviceability ──────────────────────────────────────────────────────
  {
    name: 'Serviceability',
    icon: <TravelExploreOutlinedIcon />,
    url: '/serviceability-intel/trends/overview',
    role: ['INTERNAL', 'TOOLS', 'SA'],
    submenu: [
      { name: 'By Delivery Mode', url: '/serviceability-intel/serviceability/sdd-reg', submenu: [
        { name: 'SDD — Regular', url: '/serviceability-intel/serviceability/sdd-reg' },
        { name: 'SDD — Large', url: '/serviceability-intel/serviceability/sdd-large' },
        { name: 'Same City NDD — Regular', url: '/serviceability-intel/serviceability/sc-ndd-reg' },
        { name: 'Same City NDD — Large', url: '/serviceability-intel/serviceability/sc-ndd-large' },
        { name: 'Inter City NDD — Regular', url: '/serviceability-intel/serviceability/ic-ndd-reg' },
        { name: 'Inter City NDD — Large', url: '/serviceability-intel/serviceability/ic-ndd-large' },
        { name: 'Surface Forward — Regular', url: '/serviceability-intel/serviceability/surface-reg' },
        { name: 'Surface Forward — Large', url: '/serviceability-intel/serviceability/surface-large' },
        { name: 'Forward Air — Regular', url: '/serviceability-intel/serviceability/air-reg' },
        { name: 'Forward Air — Large', url: '/serviceability-intel/serviceability/air-large' },
        { name: 'RVP with QC — Regular', url: '/serviceability-intel/serviceability/rvp-qc-reg' },
        { name: 'RVP with QC — Large', url: '/serviceability-intel/serviceability/rvp-qc-large' },
        { name: 'RVP without QC — Regular', url: '/serviceability-intel/serviceability/rvp-noqc-reg' },
        { name: 'RVP without QC — Large', url: '/serviceability-intel/serviceability/rvp-noqc-large' },
      ]},
      { name: 'Serviceability Overview', url: '/serviceability-intel/trends/overview', submenu: [
        { name: 'Serviceability Trends', url: '/serviceability-intel/trends/overview' },
        { name: 'Pan-India Delivery Reach', url: '/serviceability-intel/coverage/delivery' },
        { name: 'Pickup Reach', url: '/serviceability-intel/coverage/pickup' },
        { name: 'Upload History', url: '/serviceability-intel/coverage/uploads' },
        { name: 'Bulk Check', url: '/serviceability-intel/bulk-serviceability', role: ['INTERNAL'] },
      ]},
      { name: 'Delivery Issues', url: '/serviceability-intel/dashboard', submenu: [
        { name: 'Issue Dashboard', url: '/serviceability-intel/dashboard' },
        { name: 'Stuck Orders', url: '/serviceability-intel/stuck-orders' },
        { name: 'Stuck Trends', url: '/serviceability-intel/stuck-orders/trends' },
        { name: 'Non-Serviceable Areas', url: '/serviceability-intel/coverage/non-serviceable' },
      ]},
      { name: 'PIN Code Management', url: '/serviceability-intel/block/new', submenu: [
        { name: 'Block New PINs', url: '/serviceability-intel/block/new' },
        { name: 'Active Blocks', url: '/serviceability-intel/block/active' },
        { name: 'RTO-Based Suggestions', url: '/serviceability-intel/block/rto' },
        { name: 'PIN Analysis', url: '/serviceability-intel/coverage/analysis' },
      ]},
      { name: 'Service Type Config', url: '/serviceability-intel/servicetype/taxonomy', submenu: [
        { name: 'Taxonomy', url: '/serviceability-intel/servicetype/taxonomy' },
        { name: 'Definitions', url: '/serviceability-intel/servicetype/guide' },
        { name: 'Performance', url: '/serviceability-intel/servicetype/performance' },
        { name: 'Service Groups', url: '/serviceability-intel/setup/groups' },
        { name: 'Weight & Dimensions', url: '/serviceability-intel/weights' },
      ]},
    ],
  },

  // ── Weight & Discrepancy ────────────────────────────────────────────────
  {
    name: 'Weight & Discrepancy',
    icon: <ScaleOutlinedIcon />,
    role: ['WEIGHT_DESC', 'AP_RESTRICTED'],
    submenu: [
      { name: 'Weight Ledger', url: '/weight/ledger', role: ['WEIGHT_DESC'] },
      { name: 'Weight v2', url: '/weight/v2/disputes', submenu: [
        { name: 'Dispute Queue', url: '/weight/v2/disputes', role: ['WEIGHT_DESC'] },
        { name: 'Merchant Freeze Requests', url: '/weight/v2/freeze-requests', role: ['WEIGHT_DESC'] },
        { name: 'Dispute Settings', url: '/weight/v2/settings', role: ['WEIGHT_DESC'] },
      ]},
      { name: 'Merchant Side', url: '/weight/merchant/freeze-upload', submenu: [
        // "Courier Weight Freeze" is the name this feature carries in the weight-v2 programme docs and
        // in the merchant panel, which calls the separate v2 request flow "Merchant Weight Freeze".
        // Two screens for two different things, previously both just "freeze".
        { name: 'Courier Weight Freeze Upload', url: '/weight/merchant/freeze-upload', role: ['WEIGHT_DESC'] },
        { name: 'Courier Weight Freeze Details', url: '/weight/merchant/freeze-details', role: ['WEIGHT_DESC'] },
        { name: 'All Discrepancies', url: '/weight/merchant/all-discrepancy', role: ['WEIGHT_DESC'] },
        { name: 'Evidence Images', url: '/weight/merchant/image-link', role: ['WEIGHT_DESC'] },
      ]},
      { name: 'Courier Side', url: '/weight/courier/mis-upload', submenu: [
        { name: 'Courier MIS Upload', url: '/weight/courier/mis-upload', role: ['WEIGHT_DESC'] },
        { name: 'Bulk Action', url: '/weight/courier/bulk-action', role: ['WEIGHT_DESC'] },
        { name: 'Bulk Image Upload', url: '/weight/courier/bulk-image-upload', role: ['WEIGHT_DESC'] },
        { name: 'DWS Configuration', url: '/weight/courier/dws-config', role: ['AP_RESTRICTED'] },
        { name: 'DWS Weight Upload', url: '/weight/courier/dws-weight-upload', role: ['AP_RESTRICTED'] },
      ]},
    ],
  },

  // ── Claims & Insurance ──────────────────────────────────────────────────
  { name: 'Claims & Insurance', icon: <AssignmentLateOutlinedIcon />, url: '/claims/all', role: ['B2C_ACCESS', 'PTL_ACCESS', 'DASHBOARD', 'INTERNAL', 'TOOLS', 'NDR', 'WEIGHT_DESC', 'SA', 'AP_RESTRICTED'] },

  // ── Utilities & Tools ───────────────────────────────────────────────────
  {
    name: 'Utilities & Tools',
    icon: <BuildOutlinedIcon />,
    url: '/tools/serviceability',
    role: ['TOOLS', 'ORDER_TERMINAL_RESET', 'INTERNAL_ALERTS'],
    submenu: [
      // Internal Alerts: the internal WhatsApp alerts Proship sends to Prozo staff — recipients, on/off, history, health.
      // Gated on the INTERNAL_ALERTS module (granted per user); the module alone also reveals this menu.
      { name: 'Internal Alerts', url: '/alerts/internal', role: ['INTERNAL_ALERTS'] },
      { name: 'Lookup & Check', url: '/tools/serviceability', submenu: [
        { name: 'Serviceability Check', url: '/tools/serviceability' },
        { name: 'Bulk Serviceability', url: '/tools/bulk-serviceability', role: ['INTERNAL'] },
        { name: 'Rate Calculator', url: '/tools/rate-calculator' },
        { name: 'EDD Details', url: '/tools/edd-details' },
      ]},
      { name: 'Diagnostics', url: '/tools/carrier-logs', submenu: [
        { name: 'Carrier Logs', url: '/tools/carrier-logs' },
        { name: 'MIS from AWB', url: '/tools/awb-mis' },
        { name: 'POD from AWB', url: '/tools/awb-pod' },
        { name: 'Sorter Image', url: '/tools/sorter-image' },
        { name: 'Order Creation Latency', url: '/tools/order-creation-latency', role: ['TOOLS'] },
        { name: 'NETRA Intelligence', url: '/tools/address-quality', role: ['INTERNAL'] },
      ]},
      { name: 'Configuration', url: '/tools/qc-mapping', submenu: [
        { name: 'QC Carrier Mapping', url: '/tools/qc-mapping' },
        { name: 'Label Configuration', url: '/tools/label-config' },
        { name: 'VAS Invoicing', url: '/tools/vas-invoicing' },
        { name: 'Rate Card History', url: '/tools/rate-card-history' },
        { name: 'Reason Master', url: '/tools/reason-master', role: ['INTERNAL'] },
      ]},
      { name: 'Admin Actions', url: '/tools/refresh-url', submenu: [
        { name: 'Refresh URL', url: '/tools/refresh-url' },
        { name: 'Reset Terminal Status', url: '/tools/reset-terminal-status', role: ['ORDER_TERMINAL_RESET'] },
        // Backend is ROLE_PROSHIPADMIN only (no separate module), so gate the leaf on the JWT role.
        { name: 'Data Archival', url: '/tools/data-archival', role: ['ROLE_PROSHIPADMIN'] },
      ]},
    ],
  },

  // ── Reports & Analytics ─────────────────────────────────────────────────
  // Freight Profitability replaces the Control Tower "Org Level D2C/PTL Freight Profitability" mails.
  // Its backend requires ROLE_PROSHIPADMIN + the FREIGHT_PROFITABILITY module (granted per user from User
  // Management), so the leaf is gated on the module like every other item. Stuck Shipments replaces the CT
  // "Daily Alert – D2C/PTL Stuck Shipments" mails and is gated the same way on STUCK_SHIPMENTS.
  {
    name: 'Reports & Analytics',
    icon: <AssessmentOutlinedIcon />,
    role: ['REPORTS', 'FREIGHT_PROFITABILITY', 'STUCK_SHIPMENTS', 'INTERNAL_ALERTS'],
    submenu: [
      { name: 'Reports', url: '/finance/reports', role: ['REPORTS'] },
      { name: 'Freight Profitability', url: '/finance/freight-profitability', role: ['FREIGHT_PROFITABILITY'] },
      { name: 'Stuck Shipments', url: '/ops/stuck-shipments', role: ['STUCK_SHIPMENTS'] },
    ],
  },


  // ── Courier Setup ───────────────────────────────────────────────────────
  {
    name: 'Courier Setup',
    icon: <SettingsInputCompositeOutlinedIcon />,
    role: ['INTERNAL', 'TOOLS', 'SA'],
    submenu: [
      { name: 'Partner Management', url: '/supply/dashboard', submenu: [
        { name: 'Partner Dashboard', url: '/supply/dashboard', role: ['INTERNAL', 'TOOLS', 'SA'] },
        { name: 'Partner Directory', url: '/supply/partners', role: ['INTERNAL', 'TOOLS', 'SA'] },
        { name: 'Agreements', url: '/supply/agreements', role: ['INTERNAL', 'TOOLS', 'SA'] },
        { name: 'Courier Codes', url: '/supply/courier-codes', role: ['INTERNAL', 'TOOLS', 'SA'] },
        { name: 'Onboard New Partner', url: '/supply/partners/onboard', role: ['INTERNAL', 'TOOLS', 'SA'] },
      ]},
      { name: 'PCIS', url: '/supply/pcis-health/dashboard', submenu: [
        { name: 'Dashboard', url: '/supply/pcis-health/dashboard', role: ['INTERNAL', 'TOOLS', 'SA'] },
        { name: 'Summary', url: '/supply/pcis-health/summary', role: ['INTERNAL', 'TOOLS', 'SA'] },
        { name: 'Details', url: '/supply/pcis-health/details', role: ['INTERNAL', 'TOOLS', 'SA'] },
        { name: 'Manage', url: '/supply/pcis-health/manage', role: ['INTERNAL', 'TOOLS', 'SA'] },
        { name: 'Status Mapping', url: '/supply/pcis-health/status-mapping', role: ['INTERNAL', 'TOOLS', 'SA'] },
        { name: 'Cache', url: '/supply/pcis-health/cache', role: ['INTERNAL', 'TOOLS', 'SA'] },
        { name: 'Bluedart Origin Area', url: '/supply/pcis-health/bluedart-origin-area', role: ['INTERNAL', 'TOOLS', 'SA'] },
        { name: 'Error Code Mapping', url: '/supply/pcis-health/error-mapping', role: ['INTERNAL', 'TOOLS', 'SA'] },
        // { name: 'Serviceability', url: '/supply/pcis-health/serviceability', role: ['INTERNAL', 'TOOLS', 'SA'] }, // hidden for now — not needed yet
      ]},
      { name: 'Pricing & Zones', url: '/supply/partners/update', submenu: [
        { name: 'Rates & TAT Update', url: '/supply/partners/update', role: ['INTERNAL', 'TOOLS', 'SA'] },
        { name: 'Zone Mapping', url: '/supply/zone-mapping', role: ['INTERNAL', 'TOOLS', 'SA'] },
      ]},
      { name: 'Reconciliation', url: '/supply/invoice-recon', submenu: [
        { name: 'Invoice Recon', url: '/supply/invoice-recon', role: ['INTERNAL', 'TOOLS', 'SA'], rbacPersona: 'COM' },
        { name: 'COD Recon', url: '/supply/cod-recon', role: ['INTERNAL', 'TOOLS', 'SA'], rbacPersona: 'COM' },
        { name: 'Payments', url: '/supply/payments', role: ['INTERNAL', 'TOOLS', 'SA'], rbacPersona: 'COM' },
        { name: 'Overcharge Errors', url: '/supply/overcharge-errors', role: ['INTERNAL', 'TOOLS', 'SA'], rbacPersona: 'COM' },
      ]},
      { name: 'Legacy Configuration', url: '/courier-config/master', submenu: [
        { name: 'Courier Master', url: '/courier-config/master', role: ['INTERNAL'] },
        { name: 'Zone Mapping', url: '/courier-config/zone-mapping', role: ['TOOLS'] },
        { name: 'Zone Override', url: '/courier-config/zone-override', role: ['TOOLS'] },
        { name: 'COD Recon', url: '/courier-config/cod-recon', role: ['INTERNAL'] },
        { name: 'COD Upload', url: '/courier-config/cod-upload', role: ['INTERNAL'] },
        { name: 'Invoice Recon', url: '/courier-config/invoice-recon', role: ['INTERNAL'] },
        { name: 'Status Mapping', url: '/courier-config/status-map', role: ['SA'] },
        { name: 'Pricing Errors', url: '/courier-config/pricing-errors', role: ['TOOLS'] },
        { name: 'Direct Config', url: '/courier-config/direct', role: ['SA'] },
        { name: 'Blocked Pincodes', url: '/courier-config/bulk-pincode-block', role: ['TOOLS'] },
      ]},
    ],
  },

  // ── Merchant Setup ──────────────────────────────────────────────────────
  // Grouped by two axes, not by build order: SCOPE (per-merchant vs platform-wide)
  // and LIFECYCLE (configured once at onboarding vs operated continuously).
  //   Merchants ......... pick a merchant -> Merchant 360 (the one per-merchant surface)
  //   Onboarding ........ the once-path (wizards)
  //   KYC & Verification  a queue, worked by status
  //   Platform Defaults . settings that are NOT per-merchant
  //   Bulk Operations ... per-merchant settings edited many-at-a-time
  // The former 'Merchant Configuration' group was a strict subset of the former
  // 'Legacy Configuration' group (8/8 identical routes and components) -- both are
  // retired here and their entries redistributed across the two groups above.
  {
    name: 'Merchant Setup',
    icon: <StorefrontOutlinedIcon />,
    url: '/merchant-config/merchants',
    role: ['INTERNAL', 'TOOLS', 'FINANCE', 'MERCHANT_ONBOARDING', 'MERCHANT_KYC_APPROVAL', 'MERCHANT_ALLOCATION', 'MERCHANT_COURIER_ALLOCATION'],
    submenu: [
      { name: 'Merchants', url: '/merchant-config/merchants', submenu: [
        { name: 'All Merchants', url: '/merchant-config/merchants', role: ['INTERNAL'] },
        { name: 'D2C Merchants', url: '/merchant-config/merchants?segment=d2c', role: ['INTERNAL'] },
        // PTL Merchants moved to PTL Merchant Setup → All Merchants.
        { name: 'Courier Allocation', url: '/merchant-config/courier-allocation', role: ['MERCHANT_COURIER_ALLOCATION'] },
        { name: 'Setup Pickup Drop Mapping', url: '/merchant-config/pickup-drop-mapping', role: ['INTERNAL'] },
      ]},
      { name: 'Onboarding', url: '/merchant-config/pricing-setup/list', submenu: [
        { name: 'Onboarding Queue', url: '/merchant-config/pricing-setup/list', role: ['MERCHANT_ONBOARDING', 'INTERNAL'], rbacPersona: 'ONB' },
        { name: 'Onboarding Progress', url: '/merchant-config/pricing-setup/all', role: ['MERCHANT_ONBOARDING', 'INTERNAL'], rbacPersona: 'ONB' },
        { name: 'Step 1 · Pricing', url: '/merchant-config/pricing-setup', role: ['MERCHANT_ONBOARDING', 'INTERNAL'], rbacPersona: 'ONB' },
        { name: 'Step 2 · TAT', url: '/merchant-config/tat-setup', role: ['MERCHANT_ONBOARDING', 'INTERNAL'], rbacPersona: 'ONB' },
        { name: 'Step 3 · Allocation', url: '/merchant-config/d2c-allocation', role: ['MERCHANT_ALLOCATION', 'INTERNAL'], rbacPersona: 'ALC' },
      ]},
      { name: 'KYC & Verification', url: '/merchant-config/kyc-analytics', submenu: [
        { name: 'KYC Dashboard', url: '/merchant-config/kyc-analytics', role: ['MERCHANT_KYC_APPROVAL', 'INTERNAL'], rbacPersona: 'APR' },
        // Approved merchants are not a KYC review queue -- this lands on the Merchants
        // list pre-filtered, so the user stays inside the module instead of being
        // silently handed the unfiltered master list (the old behaviour).
        { name: 'Approved', url: '/merchant-config/merchants?kyc=approved', role: ['MERCHANT_KYC_APPROVAL', 'INTERNAL'], rbacPersona: 'APR', badgeKey: 'approved', badgeBg: 'rgba(21,128,61,0.14)', badgeColor: '#15803d' },
        { name: 'Not Started', url: '/merchant-config/kyc/not-started', role: ['MERCHANT_KYC_APPROVAL', 'INTERNAL'], rbacPersona: 'APR', badgeKey: 'notStarted', badgeBg: 'rgba(180,83,9,0.14)', badgeColor: '#b45309' },
        { name: 'Awaiting Review', url: '/merchant-config/kyc/awaiting-review', role: ['MERCHANT_KYC_APPROVAL', 'INTERNAL'], rbacPersona: 'APR', badgeKey: 'awaitingReview', badgeBg: 'rgba(3,105,161,0.14)', badgeColor: '#0369a1' },
        { name: 'Rejected', url: '/merchant-config/kyc/docs-rejected', role: ['MERCHANT_KYC_APPROVAL', 'INTERNAL'], rbacPersona: 'APR', badgeKey: 'docsRejected', badgeBg: 'rgba(185,28,28,0.14)', badgeColor: '#b91c1c' },
      ]},
      { name: 'Platform Defaults', url: '/merchant-config/default-pricing', submenu: [
        { name: 'Default Pricing', url: '/merchant-config/default-pricing', role: ['INTERNAL'] },
        { name: 'Pricing Exceptions', url: '/merchant-config/pricing-errors', role: ['TOOLS'] },
      ]},
      // Merchant zone mapping (what MERCHANT pricing uses): the platform-wide base
      // matrix (zones_map_* / PROZO_Z_MAP) + per-merchant lane overrides. New pages,
      // same APIs as the legacy Courier Setup › Legacy Configuration entries, which
      // stay in place. Courier zone maps are a different store (Courier Setup › Zones).
      { name: 'Zone Mapping', url: '/merchant-config/zones/lookup', submenu: [
        // Writes to the merchant zone map: MERCHANT_ZONE_ADMIN module, granted per user by a Proship admin
        // (backend also requires ROLE_PROSHIPADMIN). Lookup is read-only and stays on TOOLS / INTERNAL.
        { name: 'Base Zone Upload', url: '/merchant-config/zones/base-upload', role: ['MERCHANT_ZONE_ADMIN'] },
        { name: 'Zone Override', url: '/merchant-config/zones/override', role: ['MERCHANT_ZONE_ADMIN'] },
        { name: 'Zone Lookup', url: '/merchant-config/zones/lookup', role: ['TOOLS', 'INTERNAL'] },
      ]},
      { name: 'Bulk Operations', url: '/merchant-config/cod-config', submenu: [
        { name: 'Merchant COD Config', url: '/merchant-config/cod-config', role: ['FINANCE'] },
        { name: 'Product Master', url: '/merchant-config/product-master', role: ['INTERNAL'] },
        { name: 'Pickup Locations', url: '/merchant-config/pickup-locations', role: ['INTERNAL'] },
        { name: 'Delivery Locations', url: '/merchant-config/delivery-locations', role: ['INTERNAL'] },
        { name: 'NDR Auto-Rules', url: '/merchant-config/ndr-automated-rule', role: ['INTERNAL'] },
        { name: 'NPR Auto-Rules', url: '/merchant-config/npr-automated-rule', role: ['INTERNAL'] },
      ]},
    ],
  },

  // ── Finance & Billing ───────────────────────────────────────────────────
  {
    name: 'Finance & Billing',
    icon: <AccountBalanceOutlinedIcon />,
    url: '/finance/wallet',
    role: ['FINANCE'],
    submenu: [
      { name: 'Invoicing', url: '/finance/merchant-invoice', submenu: [
        { name: 'Merchant Invoices', url: '/finance/merchant-invoice' },
        { name: 'Courier Invoices', url: '/finance/courier-invoice' },
        { name: 'Invoice Corrections', url: '/finance/invoice-corrections' },
        { name: 'VAS Billing (SMS/WA)', url: '/finance/sms-wa-report' },
      ]},
      { name: 'Payments & Wallet', url: '/finance/wallet', submenu: [
        { name: 'Wallet Config', url: '/finance/wallet' },
        { name: 'Offline Payments', url: '/finance/offline-payment' },
        { name: 'Credit Limits', url: '/finance/credit-limit' },
        { name: 'Payment Details', url: '/finance/payment-details' },
        { name: 'Wallet Balances', url: '/finance/merchant-wallet' },
        { name: 'Merchant Transactions', url: '/masters/merchant-transactions' },
      ]},
      { name: 'COD', url: '/finance/cod-reconciliation', submenu: [
        { name: 'COD Reconciliation', url: '/finance/cod-reconciliation' },
        { name: 'COD Remittance', url: '/finance/cod-remittance' },
        { name: 'Auto-Remit Pending', url: '/finance/auto-remittance/pending' },
        { name: 'Auto-Remit Closed', url: '/finance/auto-remittance/close' },
        { name: 'Beneficiaries', url: '/finance/auto-remittance/beneficiary' },
        { name: 'Beneficiary Approvals', url: '/finance/auto-remittance/beneficiary-approval' },
      ]},
      { name: 'Adjustments', url: '/finance/awb-credit-note', submenu: [
        { name: 'Credit Notes', url: '/finance/awb-credit-note' },
        { name: 'Lost & Damaged', url: '/finance/lost-damage' },
      ]},
      { name: 'Financial Reports', url: '/finance/reports', submenu: [
        { name: 'Reports', url: '/finance/reports' },
        { name: 'Razorpay Dump', url: '/finance/razorpay-monthly-dump' },
      ]},
    ],
  },

  // ── Master Data ─────────────────────────────────────────────────────────
  {
    name: 'Master Data',
    icon: <StorageOutlinedIcon />,
    url: '/masters/cod-remittance-all',
    role: ['INTERNAL'],
    submenu: [
      { name: 'Financial Masters', url: '/masters/cod-remittance-all', submenu: [
        { name: 'COD Remittance (All)', url: '/masters/cod-remittance-all' },
        { name: 'Wallet Balances', url: '/masters/merchant-wallet' },
        { name: 'Credit Notes', url: '/masters/credit-note' },
        { name: 'Merchant Invoices', url: '/masters/merchant-invoice' },
        { name: 'COD Reconciliation', url: '/masters/cod-reconciliation' },
        { name: 'Merchant Transactions', url: '/masters/merchant-transactions' },
      ]},
      { name: 'Operational Masters', url: '/masters/lost-damage', submenu: [
        { name: 'Lost & Damage Claims', url: '/masters/lost-damage' },
        { name: 'Insurance Proposals', url: '/masters/insurance-order-status' },
        { name: 'Notifications', url: '/masters/notifications' },
      ]},
    ],
  },

  // ── Data Uploads ────────────────────────────────────────────────────────
  {
    name: 'Data Uploads',
    icon: <FileUploadOutlinedIcon />,
    url: '/uploads/serviceability',
    role: ['INTERNAL'],
    submenu: [
      { name: 'Serviceability', url: '/uploads/serviceability' },
      { name: 'Proof of Delivery', url: '/uploads/pods' },
      { name: 'Missing Status', url: '/uploads/bulk-status' },
      { name: 'EDD Updates', url: '/uploads/edd' },
      { name: 'Order History', url: '/uploads/order-history' },
      { name: 'Holiday Calendar', url: '/uploads/holiday-list' },
    ],
  },

  // ── D2C Pricing Agent ───────────────────────────────────────────────────
  // Single collapsible entry (like Merchant Setup / Courier Setup). Clicking it
  // expands to the three role workspaces + shared resources; each workspace
  // expands further to its own pages.
  // Role-axis gating driven by D2C_ROLE_GATING (constants.js). When true, each
  // workspace shows only for its real JWT flag (PROPOSAL_CREATE = SL · PROPOSAL_L1
  // = L1 · PROPOSAL_ADMIN = FH); shared entries show for any of the three. When
  // false (⚠️ TEMP testing bypass — backend not issuing flags yet), `role` is
  // undefined everywhere so any logged-in user sees the module. Mirrored by the
  // route guards in PrivateRoute.js.
  {
    name: 'D2C Pricing Agent',
    icon: <PriceChangeOutlinedIcon />,
    url: '/d2c-pricing',
    role: D2C_ROLE_GATING ? ['PROPOSAL_CREATE', 'PROPOSAL_L1', 'PROPOSAL_ADMIN'] : undefined,
    submenu: [
      { name: 'Sales Leader', url: '/d2c-pricing/sl/dashboard', role: D2C_ROLE_GATING ? ['PROPOSAL_CREATE'] : undefined, submenu: [
        { name: 'Dashboard', url: '/d2c-pricing/sl/dashboard' },
        { name: 'New Proposal', url: '/d2c-pricing/new-proposal' },
        { name: 'Approval Queue', url: '/d2c-pricing/sl/approval-queue' },
        { name: 'Proposal History', url: '/d2c-pricing/sl/history' },
      ]},
      // "New Proposal" appears ONLY under Sales Leader — creating proposals is
      // PROPOSAL_CREATE-only (Decision Flow v7 Stage 1 / state-machine reference §1).
      { name: 'L1 Pricing Reviewer', url: '/d2c-pricing/l1/dashboard', role: D2C_ROLE_GATING ? ['PROPOSAL_L1'] : undefined, submenu: [
        { name: 'Dashboard', url: '/d2c-pricing/l1/dashboard' },
        { name: 'Approval Queue', url: '/d2c-pricing/l1/approval-queue' },
        { name: 'Proposal History', url: '/d2c-pricing/l1/history' },
      ]},
      { name: 'Functional Head', url: '/d2c-pricing/fh/dashboard', role: D2C_ROLE_GATING ? ['PROPOSAL_ADMIN'] : undefined, submenu: [
        { name: 'Dashboard', url: '/d2c-pricing/fh/dashboard' },
        { name: 'Approval Queue', url: '/d2c-pricing/fh/approval-queue' },
        { name: 'Rules, Library & Routing', url: '/d2c-pricing/fh/rules' },
        { name: 'Supply Masters & Capability', url: '/d2c-pricing/fh/masters' },
        { name: 'Proposal History', url: '/d2c-pricing/fh/history' },
      ]},
      { name: 'GTM Toolkit', url: '/d2c-pricing/resources/gtm-toolkit', role: D2C_ROLE_GATING ? ['PROPOSAL_CREATE', 'PROPOSAL_L1', 'PROPOSAL_ADMIN'] : undefined },
      { name: 'Taxonomy & Guide', url: '/d2c-pricing/resources/guide', role: D2C_ROLE_GATING ? ['PROPOSAL_CREATE', 'PROPOSAL_L1', 'PROPOSAL_ADMIN'] : undefined },
    ],
  },

  // GrowthOS migration. Gated by GROWTHOS_ROLE_GATING (constants.js), same
  // "ship UI ahead of backend rollout" pattern as D2C_ROLE_GATING above —
  // open to any logged-in user until the backend issues GROWTHOS_ADMIN in a
  // real JWT. One parent section, one child entry per slice as they land —
  // Brands today, Marketing Budget/People/Connectors etc. follow the same
  // shape (mirrors how "D2C Pricing Agent" groups its own workspaces).
  {
    name: 'GrowthOS',
    icon: <StorefrontOutlinedIcon />,
    url: '/growthos/brands',
    role: GROWTHOS_ROLE_GATING ? ['GROWTHOS_ADMIN'] : undefined,
    submenu: [
      { name: 'Analytics', type: 'divider' },
      { name: 'Executive', url: '/growthos/executive', role: GROWTHOS_ROLE_GATING ? ['GROWTHOS_ADMIN'] : undefined },
      { name: 'Decision / Insights', url: '/growthos/decision-insights', role: GROWTHOS_ROLE_GATING ? ['GROWTHOS_ADMIN'] : undefined },
      { name: 'Marketing', role: GROWTHOS_ROLE_GATING ? ['GROWTHOS_ADMIN'] : undefined, submenu: [
        { name: 'Marketing / Funnel', url: '/growthos/marketing-funnel', role: GROWTHOS_ROLE_GATING ? ['GROWTHOS_ADMIN'] : undefined },
        { name: 'Pipeline Funnel (All)', url: '/growthos/pipeline-funnel', role: GROWTHOS_ROLE_GATING ? ['GROWTHOS_ADMIN'] : undefined },
        { name: 'Email Marketing', url: '/growthos/email-marketing', role: GROWTHOS_ROLE_GATING ? ['GROWTHOS_ADMIN'] : undefined },
        { name: 'LinkedIn / ABM', url: '/growthos/linkedin-abm', role: GROWTHOS_ROLE_GATING ? ['GROWTHOS_ADMIN'] : undefined },
      ]},
      { name: 'Sales POCs', url: '/growthos/pocs-analytics', role: GROWTHOS_ROLE_GATING ? ['GROWTHOS_ADMIN'] : undefined },
      { name: 'HubSpot Review', url: '/growthos/hubspot-review', role: GROWTHOS_ROLE_GATING ? ['GROWTHOS_ADMIN'] : undefined },
      { name: 'SME Performance', url: '/growthos/sme', role: GROWTHOS_ROLE_GATING ? ['GROWTHOS_ADMIN'] : undefined },
      { name: 'Retention (KAM)', url: '/growthos/retention', role: GROWTHOS_ROLE_GATING ? ['GROWTHOS_ADMIN'] : undefined },
      // Not built yet in this migration — shown disabled (no url) to match the real
      // GrowthOS app's nav exactly rather than silently dropping them.
      { name: 'Revenue Intelligence', tag: 'SOON', disabled: true },
      { name: 'Brands', tag: 'SOON', disabled: true },
      { name: 'Inside Sales', tag: 'SOON', disabled: true },
      { name: 'Data', type: 'divider' },
      { name: 'Connectors', url: '/growthos/connectors', role: GROWTHOS_ROLE_GATING ? ['GROWTHOS_ADMIN'] : undefined },
      { name: 'Marketing Budget', url: '/growthos/budget', role: GROWTHOS_ROLE_GATING ? ['GROWTHOS_ADMIN'] : undefined },
      { name: 'Brands', url: '/growthos/brands', role: GROWTHOS_ROLE_GATING ? ['GROWTHOS_ADMIN'] : undefined },
      { name: 'Sales POCs', url: '/growthos/pocs', role: GROWTHOS_ROLE_GATING ? ['GROWTHOS_ADMIN'] : undefined },
    ],
  },


  {
    name: 'RVP with QC',
    icon: <FactCheckOutlinedIcon />,
    url: '/admin/rvp-qc',
    // role: ['SA'],
    role: ['INTERNAL'],
    submenu: [
      { name: 'Merchant QC Setups', url: '/admin/rvp-qc', role: ['INTERNAL'] },
      { name: 'Courier QC Master', url: '/admin/rvp-qc/master', role: ['INTERNAL'] },
      { name: 'How it works', url: '/admin/rvp-qc/help', role: ['INTERNAL'] },
    ],
  },

  // ── Leadership Dashboard ────────────────────────────────────────────────
  // Visible to Proship admins (JWT role — all data) and to anyone granted the
  // SALES_DASHBOARD access module (KAM/SAM/SL — scoped server-side to the
  // merchants their salesMapping names). SidebarNew.js's roleOk() merges JWT
  // roles into the checked list, so both kinds of entries work here. Team &
  // Mapping moved to Merchant Setup → Prozo Brand Personnel Mapping.
  {
    name: 'Leadership Dashboard',
    icon: <LeaderboardRoundedIcon />,
    url: '/leadership/dashboard',
    role: ['ROLE_PROSHIPADMIN', 'SALES_DASHBOARD'],
    submenu: [
      { name: 'KAM / SAM Leadership',  url: '/leadership/dashboard?tab=1' },
      { name: 'Shipment Overview',      url: '/leadership/dashboard?tab=2' },
      { name: 'Sales Leadership',       url: '/leadership/dashboard?tab=3' },
      { name: 'Top 50 Clients',         url: '/leadership/dashboard?tab=4' },
    ],
  },

  // ── ProShip Direct ───────────────────────────────────────────────────────
  // The BYOC subscription product: a merchant brings their own courier contracts and ships on
  // them through ProShip for a plan fee. These screens are the commercial side — the catalog
  // sales quotes from, negotiated offers, and live subscriptions.
  //
  // ROLE_PROSHIPADMIN only, matching the backend: every endpoint under /api/direct/admin is
  // @PreAuthorize("hasRole('PROSHIPADMIN') or hasRole('SUPER_ADMIN')"). Gate the leaves too —
  // SidebarNew.js merges JWT roles into the access list, so the role code works at both levels.
  {
    name: 'ProShip Direct',
    icon: <RocketLaunchOutlinedIcon />,
    url: '/direct/subscriptions',
    role: DIRECT_ROLE_GATING,
    submenu: [
      { name: 'Subscriptions', url: '/direct/subscriptions', role: DIRECT_ROLE_GATING },
      { name: 'Offers',        url: '/direct/offers',        role: DIRECT_ROLE_GATING },
      { name: 'Plan Catalog',  url: '/direct/plans',         role: DIRECT_ROLE_GATING },
      { name: 'Default Accounts', url: '/direct/default-accounts', role: DIRECT_ROLE_GATING },
    ],
  },

  // ── Analytics (TASK-008) ─────────────────────────────────────────────────
  // Admin-only for now: the backend summary API (/api/allocation/dashboard/*)
  // is gated on isProshipAdmin; widen here AND there together if the viewer
  // audience ever grows.
  {
    name: 'Analytics',
    icon: <InsightsOutlinedIcon />,
    url: '/analytics/order-allocation',
    role: ['ROLE_PROSHIPADMIN'],
    submenu: [
      { name: 'Shipment Allocation Analytics', url: '/analytics/order-allocation' },
    ],
  },

  // ── KCI Management (Keep Customers Informed — event tagging) ─────────────
  // Gated on the KCI_MANAGEMENT access module (KCI_API_DOC §1) — the SAME grant
  // the /api/kci/* endpoints enforce ("KCI_MANAGEMENT access required"). So the
  // menu only appears for users who can actually load the data; anyone without
  // the grant never sees the option.
  {
    name: 'KCI Management',
    icon: <CampaignOutlinedIcon />,
    url: '/kci/dashboard',
    role: ['KCI_MANAGEMENT'],
    submenu: [
      { name: 'Create KCI Event', url: '/kci/events/create', role: ['KCI_MANAGEMENT'] },
      { name: 'KCI Dashboard', url: '/kci/dashboard', role: ['KCI_MANAGEMENT'] },
      { name: 'Manage Events', url: '/kci/events', role: ['KCI_MANAGEMENT'] },
      { name: 'Tagged Orders', url: '/kci/tagged-orders', role: ['KCI_MANAGEMENT'] },
      { name: 'Notification Config', url: '/kci/notification-config', role: ['KCI_MANAGEMENT'] },
    ],
  },

  // ═══════════════════════════════════════════════════════════════════════════
  // ██  PTL FREIGHT  ██
  // ═══════════════════════════════════════════════════════════════════════════
  { type: 'section', name: 'PTL FREIGHT' },

  {
    name: 'PTL Dashboard',
    icon: <DashboardOutlinedIcon />,
    url: '/dashboard/ptl',
    role: ['PTL_ACCESS', 'DASHBOARD'],
    submenu: [
      {name: "Today's Overview", url: '/dashboard/ptl?tab=1'},
      {name: 'Realised Revenue', url: '/dashboard/ptl?tab=3'},
      {name: 'Overall Shipments', url: '/dashboard/ptl?tab=4'},
    ],
  },

  // ── PTL Pickup Requests ─────────────────────────────────────────────────
  {
    name: 'Pickup Requests',
    icon: <LocalShippingOutlinedIcon />,
    url: '/ptl/pickups/all',
    role: ['PTL_ACCESS'],
    submenu: [
      { name: 'Quick Pickup', url: '/ptl/pickups/quick', helper: 'Serviceability and Allocation rules will not be checked.' },
      { name: 'Detailed Pickup', url: '/ptl/pickups/detailed', helper: 'Full pickup request with serviceability check and courier allocation.' },
      { name: 'All Requests', url: '/ptl/pickups/all' },
    ],
  },

  // ── PTL Shipment Management ──────────────────────────────────────────────
  {
    name: 'Shipment Management',
    icon: <AirportShuttleOutlinedIcon />,
    url: '/ptl/shipments/all',
    role: ['PTL_ACCESS'],
    submenu: [
      { name: 'All Shipments', url: '/ptl/shipments/all' },
    ],
  },

  // ── ABD Shipments (Appointment Before Delivery) ─────────────────────────
  {
    name: 'ABD Shipments',
    icon: <EventNoteOutlinedIcon />,
    url: '/appointments/all',
    role: ['PTL_ACCESS'],
    submenu: [
      { name: 'All Appointments', url: '/appointments/all' },
      { name: 'Edited Appointments', url: '/appointments/edited', role: ['INTERNAL'] },
      { name: 'Overdue Appointments', url: '/appointments/overdue', role: ['INTERNAL'] },
      { name: 'Missed & Repeat', url: '/appointments/missed-repeat' },
      { name: 'Needs Action', url: '/appointments/needs-action' },
      { name: 'ABD Consignee Tagging', url: '/appointments/abd-tagging' },
      { name: 'ABD Analytics', url: '/appointments/analytics' },
      { name: 'Bulk Upload', url: '/appointments/bulk-upload' },
      { name: 'Miss Reasons', url: '/appointments/miss-reasons', role: ['INTERNAL'] },
    ],
  },

  // ── Non-ABD Shipments (Standard PTL without appointment) ────────────────
  {
    name: 'Non-ABD Shipments',
    icon: <AirportShuttleOutlinedIcon />,
    url: '/ptl/shipments/non-abd',
    role: ['PTL_ACCESS'],
    submenu: [
      { name: 'All Shipments', url: '/ptl/shipments/non-abd' },
      { name: 'Open Shipments', url: '/ptl/shipments/non-abd/open' },
      { name: 'Stuck / Under Process', url: '/ptl/shipments/non-abd/under-process' },
      { name: 'EDD Breach Attribution', url: '/ptl/edd-breach-attribution' },
      { name: 'PTL Team Master', url: '/ptl/team-master', role: [PTL_EDD_ADMIN_ACCESS] },
    ],
  },

  // ── PTL Operations & Uploads ────────────────────────────────────────────
  {
    name: 'PTL Operations',
    icon: <BuildOutlinedIcon />,
    url: '/ptl/operations/manual-status-update',
    role: ['PTL_ACCESS'],
    submenu: [
      { name: 'Manual Status Update', url: '/ptl/operations/manual-status-update' },
      { name: 'PoD Analytics', url: '/ptl/pod-analytics' },
      { name: 'Tracking Upload', url: '/ptl/uploads/tracking' },
      { name: 'Tracking Upload V2', url: '/ptl/uploads/tracking-v2' },
      { name: 'Manifestation Upload', url: '/ptl/uploads/manifestation' },
      { name: 'Additional Charges', url: '/ptl/uploads/additional-charges' },
      { name: 'Download Labels', url: '/ptl/downloads/labels' },
      { name: 'PTL Serviceability', url: '/ptl/serviceability' },
      // ODA km bands per pincode and parent courier, and the bands → extra EDD days (PTL_ODA.md)
      { name: 'ODA Management', url: '/ptl/oda' },
    ],
  },

  // ── PTL Billing (monthly client billing) ────────────────────────────────
  {
    name: 'PTL Billing',
    icon: <ReceiptLongOutlinedIcon />,
    url: '/ptl/billing/overview',
    role: ['PTL_ACCESS'],
    submenu: [
      { name: 'Billing Overview', url: '/ptl/billing/overview' },
      { name: 'Billing Review', url: '/ptl/billing/review' },
      { name: 'Ad hoc Charges', url: '/ptl/billing/adhoc' },
      { name: 'Billing Files', url: '/ptl/billing/files' },
      { name: 'Billing Terms', url: '/ptl/billing/terms' },
    ],
  },

  // ── PTL Merchant Setup ──────────────────────────────────────────────────
  // PTL_MERCHANT_SETUP.md: onboarding (pricing → TAT → allocation), per-merchant zone map / TAT / pricing /
  // allocation, and the standard zone map and TAT every PTL merchant gets. Not the retired module below, which
  // duplicated Merchant Setup routes: these pages are PTL-only and live nowhere else.
  {
    name: 'PTL Merchant Setup',
    icon: <StorefrontOutlinedIcon />,
    url: '/ptl/merchant-setup/zone-map',
    role: ['PTL_ACCESS'],
    submenu: [
      { name: 'Onboarding', url: '/ptl/merchant-setup/onboarding', helper: 'Onboarding health of every PTL merchant: pricing, TAT, allocation.' },
      // Step 2 of the PTL merchant setup board: the standards every merchant gets, each page with its per-merchant
      // overrides as a second section (tabs), and the page to change a live merchant. Same dropdown shape as
      // Merchant Setup → Merchants.
      { name: 'All Merchants', url: '/ptl/merchant-setup/zone-map', submenu: [
        // The shared merchant list filtered to PTL merchants (opens Merchant 360); role as on the list page.
        { name: 'PTL Merchants', url: '/merchant-config/merchants?segment=ptl', role: ['INTERNAL'] },
        // One page, two sections (tabs): Standard Zone Map and Zone Map Overrides.
        { name: 'Merchant Zone Map', url: '/ptl/merchant-setup/zone-map', helper: 'Standard zone map, and merchants with their own zone for some pincodes.' },
        // One page, two sections (tabs): Standard TAT and Custom TAT.
        { name: 'Merchant TAT', url: '/ptl/merchant-setup/tat', helper: 'Prozo standard TAT by lane, and merchants with a custom TAT.' },
        { name: 'Merchant Update', url: '/ptl/merchant-setup/update', helper: 'Change rate cards, TAT, allocation or zone map of a live merchant.' },
      ]},
    ],
  },

  // ── PTL Partner Setup ───────────────────────────────────────────────────
  { name: 'PTL Partner Setup', icon: <SettingsInputCompositeOutlinedIcon />, url: '/supply/ptl', role: ['INTERNAL', 'TOOLS', 'SA'] },

  // ── PTL Merchant Setup ──────────────────────────────────────────────────
  // Retired. It re-listed four routes that already exist under Merchant Setup and
  // opened the *unfiltered* D2C merchant list, so a PTL user landed on D2C
  // merchants. PTL is a property of the merchant (isPTLMerchant), not a separate
  // module -- it is now a segment filter on the merchant list
  // (/merchant-config/merchants?segment=ptl), linked from PTL Merchant Setup -> All Merchants.

  // ═══════════════════════════════════════════════════════════════════════════
  // ██  ADMIN  ██
  // ═══════════════════════════════════════════════════════════════════════════
  { type: 'section', name: 'ADMIN' },
  {
    name: 'User & Access',
    icon: <ManageAccountsOutlinedIcon />,
    url: '/users/management',
    role: ['USER_SAVE', 'USER_RO', 'SA'],
    submenu: [
      { name: 'User Management', url: '/users/management', submenu: [
        { name: 'All Users', url: '/users/management', role: ['USER_SAVE', 'USER_RO'] },
        { name: 'PII Access Control', url: '/users/pii-access', role: ['USER_SAVE', 'USER_RO'] },
        { name: 'Audit Trails', url: '/users/audit-trails', role: ['USER_SAVE', 'USER_RO'] },
      ]},
      { name: 'System Monitoring', url: '/admin/webhooks', submenu: [
        { name: 'Webhooks', url: '/admin/webhooks', role: ['SA'] },
        { name: 'API Logs', url: '/admin/find-logs', role: ['SA'] },
        { name: 'Notification Audit', url: '/admin/notification-audit', role: ['SA'] },
        { name: 'Upload Audit', url: '/admin/upload-file-refs', role: ['SA'] },
        { name: 'Allocation Analytics', url: '/allocation/analytics', role: ['SA'] },
        { name: 'All Shipments (Debug)', url: '/allocation/all-shipments', role: ['SA'] },
      ]},
      { name: 'Bulk Operations', url: '/admin/bulk-cancellation', submenu: [
        { name: 'Bulk Cancellation', url: '/admin/bulk-cancellation', role: ['SA'] },
        { name: 'Update Merchant', url: '/admin/update-merchant', role: ['SA'] },
        // Same component as Merchant 360 -> Fulfilment -> Routing & Pincodes, kept
        // standalone for SA users who work across merchants and want the picker.
        { name: 'Routing & Pincodes (any merchant)', url: '/admin/merchant-config', role: ['SA'] },
        { name: 'Wallet Cache Reset', url: '/admin/clear-wallet-cache', role: ['SA'] },
      ]},
      { name: 'Platform Config', url: '/admin/config', submenu: [
        { name: 'Platform Settings', url: '/admin/config', role: ['SA'] },
        { name: 'Tracking Pages', url: '/admin/tracking-pages', role: ['SA'] },
        { name: 'Default Pricing Upload', url: '/admin/upload', role: ['SA'] },
        { name: 'Application Cache', url: '/admin/clear-cache', role: ['SA'] },
        { name: 'Shipyaari Mapping', url: '/admin/sy-config', role: ['SA'] },
        { name: 'Copy Courier Zones', url: '/admin/zone-copy', role: ['SA'] },
        { name: 'Insurance Config', url: '/admin/insurance-config', role: ['SA'] },
      ]},
    ],
  },

  // Bulk PII data requests with two-level approval (BRD_PII_Data_Request_Flow).
  // Visible to anyone holding ANY of the three PII grants; tabs inside the page
  // narrow further (New/My = PII_REQUEST, Pending Approvals = approver grants).
  {
    name: 'PII Data Requests',
    icon: <ShieldOutlinedIcon />,
    url: '/pii-requests',
    role: ['PII_REQUEST', 'PII_APPROVER_L1', 'PII_APPROVER_L2'],
  },
]

export default MENU_ITEMS
